import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface LocationState {
  bankName?: string;
  bankAccount?: string;
  bankAccountHolder?: string;
  packageName?: string;
  packagePrice?: number;
}

const PurchaseResultPage = () => {
  const location = useLocation();
  const state = location.state as LocationState | null;

  useEffect(() => {
    document.title = "구매 신청";
  }, []);

  useEffect(() => {
    if (typeof (window as any).fbq === "function") {
      (window as any).fbq("track", "CompleteRegistration");
    }
  }, []);

  const hasBankInfo = state?.bankName && state?.bankAccount && state?.bankAccountHolder;

  return (
    <div className="main_container">
      <main
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "24px",
          textAlign: "center",
        }}
      >
        {/* 체크 아이콘 */}
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            backgroundColor: "#4CAF50",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "24px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>

        <h1
          style={{
            fontSize: "24px",
            fontWeight: 700,
            marginBottom: "16px",
            color: "#333",
          }}
        >
          구매 신청이 완료되었습니다
        </h1>

        <p
          style={{
            fontSize: "16px",
            color: "#666",
            marginBottom: "8px",
            lineHeight: 1.6,
          }}
        >
          카카오톡 알림톡으로 안내 메시지를 보내드렸습니다.
        </p>

        {/* 결제 정보 */}
        {hasBankInfo && (
          <div
            style={{
              width: "100%",
              maxWidth: "400px",
              marginTop: "24px",
              padding: "20px",
              backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              textAlign: "left",
            }}
          >
            <div
              style={{
                fontSize: "16px",
                fontWeight: 600,
                marginBottom: "16px",
                color: "#333",
              }}
            >
              입금 안내
            </div>

            {state?.packageName && (
              <div style={{ marginBottom: "12px" }}>
                <div style={{ fontSize: "14px", color: "#666", marginBottom: "4px" }}>상품</div>
                <div style={{ fontSize: "16px", fontWeight: 500, color: "#333" }}>
                  {state.packageName}
                </div>
              </div>
            )}

            {state?.packagePrice && (
              <div style={{ marginBottom: "12px" }}>
                <div style={{ fontSize: "14px", color: "#666", marginBottom: "4px" }}>금액</div>
                <div style={{ fontSize: "18px", fontWeight: 600, color: "#4F46E5" }}>
                  {state.packagePrice.toLocaleString()}원
                </div>
              </div>
            )}

            <div
              style={{
                marginTop: "16px",
                paddingTop: "16px",
                borderTop: "1px solid #e5e7eb",
              }}
            >
              <div style={{ fontSize: "14px", color: "#666", marginBottom: "4px" }}>입금 계좌</div>
              <div style={{ fontSize: "16px", fontWeight: 500, color: "#333" }}>
                {state?.bankName} {state?.bankAccount}
              </div>
              <div style={{ fontSize: "14px", color: "#666", marginTop: "4px" }}>
                예금주: {state?.bankAccountHolder}
              </div>
            </div>

            <div
              style={{
                marginTop: "16px",
                padding: "12px",
                backgroundColor: "#fff3cd",
                borderRadius: "8px",
                fontSize: "14px",
                color: "#856404",
                lineHeight: 1.5,
              }}
            >
              입금 확인 후 카카오톡으로 안내해드립니다.
            </div>
          </div>
        )}

        <p
          style={{
            fontSize: "14px",
            color: "#999",
            marginTop: "24px",
            lineHeight: 1.6,
          }}
        >
          카카오톡을 확인해주세요!
        </p>
      </main>
    </div>
  );
};

export default PurchaseResultPage;